import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {Subscription} from 'rxjs';
import {MatSelectChange} from '@angular/material/select';
import {BookingV2StateService} from '../../../services/booking-v2-state.service';
import {
  AlertStateEnum,
  StaffMembersSelectorEnum,
  TherapistChoiceEnum,
} from '../../../enums/booking-enums';
import {BookingV2ManagerService} from '../../../services/booking-v2-manager.service';
import {BookingV2DataService} from '../../../services/booking-v2-data.service';
import {BookingProviderDetails} from '../../../types/booking-provider-details';

@Component({
  selector: 'app-no-slots-available-doctor',
  templateUrl: './no-slots-available-doctor.component.html',
  styleUrls: ['./no-slots-available-doctor.component.scss'],
})
export class NoSlotsAvailableDoctorComponent implements OnInit, OnDestroy {
  @Output() allStuff = new EventEmitter<MatSelectChange>();
  @Output() staffSelectClick = new EventEmitter<boolean>();

  public isAlertVisible: boolean = false;
  public isDoctorMandatory: boolean = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private bookingState: BookingV2StateService,
    private bookingManager: BookingV2ManagerService,
    private bookingData: BookingV2DataService
  ) {}

  ngOnInit(): void {
    this.setListeners();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  public redirectToNext(): void {
    this.bookingManager.checkAvailableTimesInNext60DaysAndRedirect();
  }

  public redirectToAll(): void {
    const event: MatSelectChange = {
      source: null,
      value: StaffMembersSelectorEnum.OPTION_ANY_ID,
    };
    this.allStuff.emit(event);
  }

  public openDoctorSelector(): void {
    this.staffSelectClick.emit(true);
  }

  private processAlertsState(state: number): void {
    this.isAlertVisible = state === AlertStateEnum.NO_TIMESLOTS_FOR_DOCTOR;
  }

  private processProviderDetails(
    providerDetails: BookingProviderDetails
  ): void {
    this.isDoctorMandatory =
      providerDetails.therapistChoice &&
      providerDetails.therapistChoice === TherapistChoiceEnum.REQUIRED;
  }

  private setListeners(): void {
    this.subscriptions.push(
      this.bookingState.state$.subscribe((result) =>
        this.processAlertsState(result.alert)
      ),
      this.bookingData.providerDetails$.subscribe((result) =>
        this.processProviderDetails(result)
      )
    );
  }
}
